import React from 'react';
// import { useWhitelabelByIndexHTML } from 'lane-shared/hooks/useWhitelabelByIndexHTML';

import { OnboardingBuilding } from 'components/onboarding/Onboarding/OnboardingSteps/OnboardingBuilding';

export function OnboardingTestingBuilding() {
  // const whitelabel = useWhitelabelByIndexHTML();

  return (
    <OnboardingBuilding
      building={null}
      onboardingState="loading"
      errorMessage="onboarding completion error"
      userName="onboarding tester"
      // whitelabel={whitelabel}
      onComplete={() => {}}
      onContinue={() => {}}
      onOnboardingComplete={() => {}}
      onClear={() => {}}
    />
  );
}

export default OnboardingTestingBuilding;
